import app, { Component, on } from 'apprun';
import {registration} from '../api';

interface IMessage{
  ID: string;
  MessageText: string;
  StatusFlag: string;
  CreationDate: string;
}
interface IState{
  messages:Array<IMessage>;
  allCheck: boolean;
  search: string;
}
export default class MessageCenterComponent extends Component {
  state: IState = {
    messages: [{ ID: '', MessageText: '', StatusFlag: '', CreationDate:'' }],
    allCheck: false,
    search: ''
  };

  MessageList = ({messages}) => {    
    if (!messages) return;
    
    
    return <ul className="list-group">
        {
          messages.map(message=>message.StatusFlag==='Delete'?
            <li className="list-group-item-message-center">
              <span className="message-read-icon-disappear" ><a href="" onclick={() => this.run('delete', message.ID)}><i className="fa fa-times"></i></a></span>
                <div>{`_html:${message.MessageText}`} 
                  <label className="pull-right">
                    <h4 >
                      {`_html:${message.CreationDate.toLocaleString().slice(0,10)}`}
                    </h4>
                  </label>
                </div>
            </li> :

            <li className="list-group-item-message-center">
              <span className="pull-right" ><a href="" onclick={() => this.run('delete', message.ID)}><i className="fa fa-times"></i></a></span>
                <div>{`_html:${message.MessageText}`} 
                  <label className="pull-right">
                    <h4 >
                      {`_html:${message.CreationDate.toLocaleString().slice(0,10)}`}
                    </h4>
                  </label>
                </div>
            </li> 
            )
        }
    </ul>
  }

  view = (state:IState) => {
    // const messageID = state.messages[0].ID;
    const messages = state.messages.filter(x=>state.allCheck || x.StatusFlag !== 'Delete')
                                   .filter(x=>!state.search || x.MessageText.toUpperCase().indexOf(state.search.toUpperCase()) > -1)
    return (
      <div>
        <h1> Welcome to Message Center</h1>
        <div style={{'margin-bottom':'20px'}}>
          <input oninput={e=> this.run('search', e)} placeholder="Search ..."/>
          <label className="pull-right">&nbsp;&nbsp;<input type="checkbox" id="allCheck" value="all" checked={state.allCheck} oninput={e=> this.run('all', e) }/> All </label>&nbsp;
          <label className="pull-right">&nbsp;&nbsp;<input type="checkbox" id="unReadCheck" checked={!state.allCheck} oninput={e=> this.run('unRead', e) } /> New </label>&nbsp;
        </div>
        <div><this.MessageList messages={messages} /></div>
      </div>
    );
  };

  update = {
    '#': async (state:IState) => {
      let messages = await registration.getMessages();
      return { ...state, messages};
    },
    delete: async (state:IState, id) => {
        // console.log('delete message center component');
        try {
          await registration.deleteMessages(id);
          let messages = await registration.getMessages();//state.messages.filter(x=>x.ID != id)
          return { ...state, messages };
        } catch (err){
          return {err: err.message, id};
        }
      },
      all : state => ({ ...state, allCheck: true}),
      unRead : state => ({ ...state, allCheck: false})  ,    
      search : (state, e) => ({ ...state, search: e.target.value})      
   };
}

new MessageCenterComponent().mount('ms-app');
